// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'speaker-on-solid';

export const Component = () => (
  <path d='M19.188 9.323c.335 0 .527.191.527.526v6.849c0 .335-.192.479-.527.479s-.479-.144-.479-.48V9.85c0-.335.144-.526.48-.526Zm3.449-1.437v10.776c0 .335-.144.479-.48.479-.334 0-.478-.144-.478-.48V7.887c0-.335.144-.527.479-.527.335 0 .479.192.479.527Zm-5.89-3.4v15.708c0 .431-.145.766-.432 1.054-.24.239-.623.382-1.054.382-.383 0-.67-.096-.91-.287l-5.46-4.598H3.958a.946.946 0 0 1-.67-.287.946.946 0 0 1-.288-.67V8.89c0-.24.096-.48.288-.67a.946.946 0 0 1 .67-.288H8.89l5.459-4.598c.335-.239.67-.335.91-.335.431 0 .767.144 1.054.431.288.288.431.623.431 1.054h.001Z' />
);

export const viewBox = '0 0 25 25';
